module.exports = __webpack_public_path__ + "static/media/MaxZim.c9ace673.mp3";